import { DailySalesDataTableFooter } from "@/components/DataTable/dailySalesDataTableFooter";
import { GridPagination } from "@mui/x-data-grid";

export default function DailySalesFooter(props) {
  return (
    <>
      <DailySalesDataTableFooter {...props}></DailySalesDataTableFooter>
      <GridPagination></GridPagination>
    </>
  );
}
